import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


/* Pipes */
import { RoleNamePipe } from '../_pipes/role.pipe';
import { KeysPipe } from '../_pipes/keyvalue.pipe';
import { CamelCaseToSpacePipe } from '../_pipes/camelcase.pipe';
import { CapitaliseWordsPipe } from 'app/_pipes/capitalise-words.pipe';

/* Directives */
import { DisableControlDirective } from '../_directives/disable-control.directive';
import { SwitchCasesDirective } from '../_directives/switch-cases.directive';
import { TextareaAutoresizeDirective } from '../_directives/textarea-autoresize.directive';
import { OnlyNumbersDirective } from '../_directives/only-numbers.directive';

/* PrimeNg */
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { LightboxModule } from 'ngx-lightbox';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { SidebarModule } from 'primeng/sidebar';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuItem } from 'primeng/api';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';

/* Ng-bootstrap */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Components & Modules*/
import { CardTabsComponent } from '../components/cardtabs/cardtabs.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { ReportsComponent } from '../reports/reports.component';
import { SiteFromReportComponent } from '../reports/site-form-report/site-form-report.component';
import { RestrictionsReportComponent } from 'app/reports/restrictions-report/restrictions-report.component';
import { SiteInductionReportComponent } from '../reports/site-induction-report/site-induction-report.component';
import { DynamicFormModule } from '../_dynamic_form/dynamic-form.module';
import { SitesComponent } from 'app/admin-sites/sites.component';
import { WorkerSiteList as ContractorWorkerSitesComponent } from 'app/shared-pages/worker-site-list/worker-site-list.component';
import { SiteTabMenuComponent } from 'app/shared-pages/site-pages/site-tab-menu/site-tab-menu.component';
import { SitesComponent as SiteOwnerSitesComponent } from 'app/site-owner-sites/sites.component';
import { SiteDetailsComponent } from 'app/admin-sites/single-site/details/site-details.component';
import { SiteDetailsComponent as SiteOwnerDetailsComponent } from 'app/site-owner-sites/single-site/details/site-details.component';
import { SiteAssetsComponent } from 'app/shared-pages/site-pages/site-assets/site-assets.component';
import { AddEditAssetComponent } from 'app/shared-pages/site-pages/site-assets/add-edit-asset/add-edit-asset.component';
import { SiteNotesComponent } from 'app/shared-pages/site-pages/site-notes/site-notes.component';
import { SiteLocationComponent } from 'app/shared-pages/site-pages/site-location/site-location.component';
import { SiteWorkOrdersComponent } from 'app/shared-pages/site-pages/site-work-orders/site-work-orders.component';
import { WorkOrderComponent } from 'app/shared-pages/work-order/work-order.component';
import { SiteWorkersComponent } from 'app/shared-pages/site-pages/site-workers/site-workers.component';
import { InvitedUsersComponent } from 'app/shared-pages/site-pages/invited-users/invited-users.component';
import { AssetCertificateComponent } from 'app/shared-pages/site-pages/site-assets/asset-certification/asset-certificate.component';
import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { CreateSiteComponent } from 'app/admin-sites/create-site/create-site.component';
import { SiteContactsComponent } from 'app/shared-pages/site-pages/site-contact-info/site-contact-info.component';
import { SiteRestrictionsComponent } from 'app/shared-pages/site-pages/site-restrictions/site-restrictions.component';
import { SiteIncidentsComponent } from 'app/shared-pages/site-pages/site-incidents/site-incidents.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ContractorDetailsComponent } from 'app/admin-contractors/contractors/details/contractor-details.component';
import { ContractorDetailsComponent as SharedContractorDetailsComponent } from 'app/shared-pages/contractors/contractor-details/contractor-details.component';
import { ContractorWorkersComponent } from 'app/admin-contractors/contractors/workers/contractor-workers.component';
import { ContractorWorkersComponent as SharedContractorWorkersComponent } from 'app/shared-pages/contractors/contractor-workers/contractor-workers.component';
import { SiteDocumentsComponent } from 'app/shared-pages/site-pages/site-documents/site-documents.component';
import { SiteOwnerUsersComponent } from 'app/admin-users/site-owners/site-owners.component';
import { ContractorManagersComponent } from 'app/admin-users/contractor-managers/contractor-managers.component';
import { AssetTypesComponent } from 'app/admin-asset-types/asset-types.component';
import { UserSearchComponent } from 'app/admin-users/user-search/user-search.component';
import { SiteTypesComponent } from 'app/admin-site-types/site-types.component';
import { CompetencyTypesComponent } from 'app/admin-competency-types/competency-type.component';
import { ContractorsComponent } from 'app/admin-contractors/contractors.component';
import { LiveSessionsComponent } from 'app/shared-pages/live-sessions/live-sessions.component';
import { SiteSessionsComponent } from 'app/site-owner-sessions/site-sessions/site-sessions.component';
import { WorkerSessionsComponent } from 'app/site-owner-sessions/worker-sessions/worker-sessions.component';
import { SessionPhotoModalComponent } from 'app/site-owner-sessions/session-photo-modal/session-photo-modal.component';
import { SiteFormModalComponent } from 'app/site-owner-sessions/worker-sessions/site-form-modal/site-form-modal.component';
import { ContractorContactsComponent } from 'app/admin-contractors/contractors/contacts/contractor-contacts.component';
import { SiteMapComponent } from 'app/site-map/site-map.component';
import { WorkOrdersOverviewComponent } from 'app/shared-pages/work-orders-overview/work-orders-overview.component';
import { SiteWorkOrderProceduresComponent } from 'app/shared-pages/site-pages/site-work-order-procedures/site-work-order-procedures.component';
import { SafePipe } from 'app/_pipes/safe-url';
import { AccordionSectionComponent } from './accordion-section/accordion-section.component';
import { DateRangeFriendlyComponent } from './date-range-friendly/date-range-friendly.component';
import { ActionBarComponent } from 'app/shared-pages/work-order/components/action-bar/action-bar.component';
import { TocCompetencyRowComponent } from 'app/shared-pages/work-order/components/toc-competency-row/toc-competency-row.component';
import { AddDocumentsComponent } from 'app/shared-pages/work-order/components/add-documents/add-documents.component';
import { ChangeStatusModalComponent } from 'app/shared-pages/work-order/components/change-status-modal/change-status-modal.component';
import { CheckoutModalComponent } from 'app/shared-pages/work-order/components/checkout-modal/checkout-modal.component';
import { EditCompetenciesComponent } from 'app/shared-pages/work-order/components/edit-competencies/edit-competencies.component';
import { EditSiteRequiredCompetenciesComponent } from 'app/shared-pages/site-pages/site-session-competencies/edit-site-required-competencies/edit-site-required-competencies.component';
import { EditScheduleModalComponent } from 'app/shared-pages/work-order/components/edit-schedule-modal/edit-schedule-modal.component';
import { EditDescriptionModalComponent } from 'app/shared-pages/work-order/components/edit-description-modal/edit-description-modal.component';
import { EditMinPartyModalComponent } from 'app/shared-pages/work-order/components/edit-min-party-modal/edit-min-party-modal.component';
import { EditSiteFormModalComponent } from 'app/shared-pages/work-order/components/edit-site-form-modal/edit-site-form-modal.component';
import { StepProgressBarComponent } from 'app/shared-pages/work-order/components/step-progress-bar/step-progress-bar.component';
import { DateFriendlyComponent } from './date-friendly/date-friendly.component';
import { WorkOrderStateBadgeComponent } from './work-order-state-badge/work-order-state-badge.component';
import { SignatureUploadComponent } from './signature-upload/signature-upload.component';
import { CompetencyCardComponent } from './competency-card/competency-card.component';
import { DashboardComponent } from '../shared-pages/dashboard/dashboard.component';
import { LargeNumberDisplayComponent } from '../shared-pages/dashboard/components/large-number-display/large-number-display.component';
import { WorkOrderBarGraphComponent } from '../shared-pages/dashboard/components/work-order-bar-graph/work-order-bar-graph.component';
import { DashboardCardComponent } from '../shared-pages/dashboard/components/dashboard-card/dashboard-card.component';
import { OverdueHealthCheckListComponent } from '../shared-pages/dashboard/components/overdue-health-check-list/overdue-health-check-list.component';
import { TextFilterBoxComponent } from '../shared-pages/dashboard/components/text-filter-box/text-filter-box.component';
import { PluralPipe } from 'app/_pipes/plural.pipe';
import { FileNamePipe } from 'app/_pipes/file-name.pipe';
import { WorkOrderModalComponent } from '../shared-pages/dashboard/modals/work-order-modal/work-order-modal.component';
import { LiveSessionsModalComponent } from '../shared-pages/dashboard/modals/live-sessions-modal/live-sessions-modal.component';
import { AutoTableComponent } from '../shared-pages/dashboard/components/auto-table/auto-table.component';
import { SiteFormsComponent } from '../shared-pages/site-forms/site-forms.component';
import { SiteFormsDetailsComponent } from '../shared-pages/site-forms/site-forms-details/site-forms-details.component';
import { SiteFormsCreateComponent } from '../shared-pages/site-forms/site-forms-create/site-forms-create.component';
import { DragulaModule } from 'ng2-dragula';
import { SiteFormsResponseComponent } from '../shared-pages/site-forms/site-forms-response/site-forms-response.component';
import { SiteFormsResponsesTableComponent } from '../shared-pages/site-forms/components/site-form-responses-table/site-form-responses-table.component';
import { SiteFormsPreviewComponent } from '../shared-pages/site-forms/components/site-forms-preview/site-forms-preview.component';
import { SiteFormsLinkSitesModalComponent } from '../shared-pages/site-forms/components/site-forms-link-sites-modal/site-forms-link-sites-modal.component';
import { SiteFormEntryModalComponent } from 'app/shared-pages/site-pages/site-work-orders/site-form-entry/site-form-entry-modal.component';
import { SiteFormTableModalComponent } from 'app/shared-pages/site-pages/site-work-orders/site-form-entry/site-forms-table/site-form-table-modal.component';
import { SafeStylePipe } from 'app/_pipes/safe-style.pipe';
import { InviteUsersComponent } from '../shared-pages/invite-users/invite-users.component';
import { ResultsModalComponent } from '../shared-pages/invite-users/results-modal/results-modal.component';
import { ProcedureFormPageComponent } from 'app/shared-pages/site-pages/site-work-order-procedures/form-page/procedure-form-page.component';
import { ProcedureDetailsPageComponent } from 'app/shared-pages/site-pages/site-work-order-procedures/details-page/procedure-details-page.component';
import { WorkOrderFormComponent } from 'app/shared-pages/site-pages/site-work-orders/form/work-order-form.component';
import { InboxComponent } from '../shared-pages/workflow-items/inbox/inbox.component';
import { AssetRestrictionApprovalComponent } from '../shared-pages/site-pages/site-assets/asset-restriction-approval/asset-restriction-approval.component';
import { SiteRestrictionApprovalComponent } from 'app/shared-pages/site-pages/site-restriction-approval/site-restriction-approval.component';
import { ScheduleDisplaySectionComponent } from 'app/shared-pages/work-order/components/schedule-display-section/schedule-display-section.component';
import { CreateFromProcedureFormPageComponent } from 'app/shared-pages/site-pages/site-work-order-procedures/create-from-procedure-form-page/create-from-procedure-form-page.component';
import { AssetPageComponent } from '../shared-pages/site-pages/site-assets/asset-page/asset-page/asset-page.component';
import { EditAvailabilityModalComponent } from '../shared-pages/site-pages/site-assets/asset-page/edit-availability-modal/edit-availability-modal.component';
import { AddAvailabilityModalComponent } from '../shared-pages/site-pages/site-assets/asset-page/add-availability-modal/add-availability-modal.component';
import { AvailabilityHistoryComponent } from '../shared-pages/site-pages/site-assets/asset-page/availability-history/availability-history.component';
import { InviteContractorComponent } from '../shared-pages/invite-contractor/invite-contractor.component';
import { ContractorCertificateApprovalComponent } from 'app/shared-pages/contractors/contractor-certificate-approval/contractor-certificate-approval.component';
import { WorkerCertificateApprovalComponent } from 'app/shared-pages/contractors/worker-certificate-approval/worker-certificate-approval.component';
import { ContractorDashboardComponent } from '../contractor-manager/contractor-dashboard/contractor-dashboard.component';
import { AddCertificateModalComponent } from '../shared-pages/invite-contractor/add-certificate-modal/add-certificate-modal.component';
import { AdminUsersComponent } from '../admin-users/admin-users.component';
import { AdminManageTypesComponent } from '../admin-manage-types/admin-manage-types.component';
import { ContractorCertificatesComponent as ContractorManagerContractorCertificatesComponent } from '../contractor-manager/contractor/certificates/certificates.component';
import { ContractorCertificatesComponent as PowerStationOwnerContractorCertificatesComponent } from '../shared-pages/contractors/contractor-certificates/contractor-certificates.component';
import { ContractorsListComponent } from '../shared-pages/contractors/contractors-list/contractors-list.component';
import { ContractorWorkerPageComponent } from '../shared-pages/contractors/contractor-worker-page/contractor-worker-page.component';
import { IntlPhoneCodeFieldComponent } from './intl-phone-code-field/intl-phone-code-field.component';
import { ManageTrainingsComponent } from '../training-and-inductions/site-owner/manage-trainings/manage-trainings.component';
import { TrainingPageComponent } from '../training-and-inductions/site-owner/training-page/training-page.component';
import { EditVideoSectionModalComponent } from '../training-and-inductions/site-owner/sections/edit-video-section-modal/edit-video-section-modal.component';
import { EditPdfSectionModalComponent } from '../training-and-inductions/site-owner/sections/edit-pdf-section-modal/edit-pdf-section-modal.component';
import { TrainingOverviewComponent } from '../training-and-inductions/trainee/training-overview/training-overview.component';
import { TrainingSectionComponent } from '../training-and-inductions/trainee/training-section/training-section.component';
import { TrainingVideoComponent } from '../training-and-inductions/trainee/sections/training-video/training-video.component';
import { TrainingPdfComponent } from '../training-and-inductions/trainee/sections/training-pdf/training-pdf.component';
import { TrainingQuestionComponent } from '../training-and-inductions/trainee/sections/training-question/training-question.component';
import { EditTrainingPageComponent } from '../training-and-inductions/site-owner/edit-training-page/edit-training-page.component';
import { WorkerTrainingListComponent } from '../training-and-inductions/worker/worker-training-list.component';
import { ContractorAcceptanceListComponent } from 'app/training-and-inductions/contractor/contractor-acceptance-list.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { QuestionsPageComponent } from 'app/training-and-inductions/site-owner/questions-page/questions-page.component';
import { AssignTrainingModalComponent } from 'app/shared-pages/site-pages/site-workers/assign-training-modal/assign-training-modal.component';
import { ResendInductionReminderModalComponent } from 'app/shared-pages/site-pages/site-workers/resend-induction-reminder-modal/resend-induction-reminder-modal.component';
import { WorkerCompetencyAndTrainingReportComponent } from 'app/reports/worker-competency-and-training-report/worker-competency-and-training-report.component';
import { CompetencyReports } from 'app/reports/competency-reports/competency-reports.component';
import { ContractorCompetencyReport } from 'app/reports/contractor-competency-report/contractor-competency-report.component';
import { CompetencyShortNamePipe } from 'app/_pipes/competency-short-name.pipe';
import { CompetencyBadgeColorPipe } from 'app/_pipes/competency-badge-color.pipe';
import { ConfinedSpaceCompetencyAndTrainingReportComponent } from '../reports/confined-space-competency-and-training-report/confined-space-competency-and-training-report.component';
import { WorkerSitesComponent } from 'app/worker-views/worker-sites/worker-sites.component';
import { ChangePasswordModalComponent } from '../user-profile/change-password-modal/change-password-modal.component';
import { GroupedCompetencyMultiselectComponent } from './grouped-competency-multiselect/grouped-competency-multiselect.component';
import { SiteSessionCompetenciesComponent } from '../shared-pages/site-pages/site-session-competencies/site-session-competencies.component';
import { ContractorSiteOwnerLinksComponent } from '../admin-contractor-site-owner-links/contractor-site-owner-links/contractor-site-owner-links.component';
import { AddContractorSiteOwnerLinkModalComponent } from '../admin-contractor-site-owner-links/add-contractor-site-owner-link-modal/add-contractor-site-owner-link-modal.component';
import { CheckInComponent } from '../shared-pages/check-in/check-in.component';
import { ChooseWorkersModalComponent } from '../shared-pages/check-in/choose-workers-modal/choose-workers-modal.component';
import { ChooseWorkOrderModalComponent } from '../shared-pages/check-in/choose-work-order-modal/choose-work-order-modal.component';
import { SiteScheduleComponent } from '../shared-pages/schedule-view/site-schedule/site-schedule.component';
import { AllSiteScheduleComponent } from '../shared-pages/schedule-view/all-site-schedule/all-site-schedule.component';
import { SchedulerComponent } from '../shared-pages/schedule-view/components/scheduler/scheduler.component';
import { AdminAllSiteScheduleComponent } from '../shared-pages/schedule-view/admin-all-site-schedule/admin-all-site-schedule.component';
import { SchedulerFiltersComponent } from '../shared-pages/schedule-view/components/scheduler-filters/scheduler-filters.component';
import { WorkerSearchComponent } from '../shared-pages/user-management/worker-search/worker-search.component';
import { UserSiteDetailsComponent } from '../shared-pages/user-management/user-site-details/user-site-details.component';
import { ManageWorkerCompetenciesComponent } from '../shared-pages/user-management/manage-worker-competencies/manage-worker-competencies.component';
import { EditWorkerSiteModalComponent } from '../shared-pages/user-management/user-site-details/components/edit-worker-site-modal/edit-worker-site-modal.component';
import { MultiEditChooseSiteTypeModalComponent } from '../shared-pages/user-management/user-site-details/components/multi-edit-choose-site-type-modal/multi-edit-choose-site-type-modal.component';
import { ApproveAvailabilityModalComponent } from 'app/shared-pages/site-pages/site-assets/asset-page/approve-availabilty-modal/approve-availabilty-modal.component';
import { ViewPendingScheduleItemsModal } from 'app/shared-pages/schedule-view/components/view-pending-schedule-items-modal/view-pending-schedule-items-modal.component';
import { ApproveCancelledAvailabilityModalComponent } from 'app/shared-pages/site-pages/site-assets/asset-page/approve-cancelled-availabilty-modal/approve-cancelled-availabilty-modal.component';
import { UserDetailsModalComponent } from 'app/shared-pages/work-order/components/user-details-modal/user-details-modal.component';
import { UsernameDisplayComponent } from 'app/shared-pages/work-order/components/username-display/username-display.component';
import { WorkerScheduleSiteListComponent } from '../shared-pages/schedule-view/worker-schedule-site-list/worker-schedule-site-list.component';
import { WorkerSiteScheduleComponent } from '../shared-pages/schedule-view/worker-site-schedule/worker-site-schedule.component';
import { SiteFormResponsePreviewPaneComponent } from '../shared-pages/site-forms/components/site-form-response-preview-pane/site-form-response-preview-pane.component';
import { OemProceduresComponent } from 'app/contractor-manager/contractor/procedures/oem-procedures.component';
import { SendEmailComponent } from 'app/admin-users/admin-send-email/send-email.component';
import { SiteSiteSessionsComponent } from '../shared-pages/site-pages/site-site-sessions/site-site-sessions.component';
import { ContractorListForTrainingComponent } from '../training-and-inductions/site-owner/contractor-list-for-training/contractor-list-for-training.component';
import { WorkOrderSearchFieldComponent } from './work-order-search-field/work-order-search-field.component';
import { SkeletonLoadingRowComponent } from './skeleton-loading-row/skeleton-loading-row.component';
import { SkeletonLoadingFieldComponent } from './skeleton-loading-field/skeleton-loading-field.component';
import { SkeletonLoadingCardGridComponent } from './skeleton-loading-card-grid/skeleton-loading-card-grid.component';
import { CardSectionHeaderComponent } from './card-section-header/card-section-header.component';
import { TableActionBarComponent } from './table-action-bar/table-action-bar.component';
import { TopBannerComponent } from './top-banner/top-banner.component';
import { FilterToggleGroupComponent } from './filter-toggle-group/filter-toggle-group.component';
import { FilterSummaryDisplayComponent } from './filter-summary-display/filter-summary-display.component';
import { AcceptCompetencyModalComponent } from './accept-competency-modal/accept-competency-modal.component';
import { RejectCompetencyModalComponent } from './reject-competency-modal/reject-competency-modal.component';
import { UploadEvidenceModalComponent } from './upload-evidence-modal/upload-evidence-modal.component';
import { AddCompetencyFormComponent } from './add-competency-form/add-competency-form.component';
import { WorkerManageCompetenciesComponent } from '../worker-views/worker-manage-competencies/worker-manage-competencies.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ConfirmDialogModule,
    CalendarModule,
    FileUploadModule,
    LightboxModule,
    TableModule,
    PaginatorModule,
    SidebarModule,
    CheckboxModule,
    RadioButtonModule,
    InputSwitchModule,
    DropdownModule,
    AccordionModule,
    ContextMenuModule,
    DynamicFormModule,
    DragulaModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCZ-y3Wxl3NFCnKnjJY3WtNsVhS3DHYTiA',
      libraries: ['places'],
    }),
    GooglePlaceModule,
    ColorPickerModule,
    MultiSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    ProgressSpinnerModule,
    ProgressBarModule,
  ],
  declarations: [
    WorkerSitesComponent,
    CardTabsComponent,
    UserProfileComponent,
    ReportsComponent,
    SiteInductionReportComponent,
    SiteFromReportComponent,
    RestrictionsReportComponent,
    CompetencyReports,
    ContractorCompetencyReport,
    WorkerCompetencyAndTrainingReportComponent,
    ConfinedSpaceCompetencyAndTrainingReportComponent,
    RoleNamePipe,
    FileNamePipe,
    KeysPipe,
    SafePipe,
    SafeStylePipe,
    CamelCaseToSpacePipe,
    CapitaliseWordsPipe,
    SitesComponent,
    ContractorWorkerSitesComponent,
    SiteTabMenuComponent,
    SiteOwnerSitesComponent,
    SiteDetailsComponent,
    SiteOwnerDetailsComponent,
    SiteAssetsComponent,
    SiteDocumentsComponent,
    SiteNotesComponent,
    SiteLocationComponent,
    SiteWorkOrdersComponent,
    WorkOrderComponent,
    SiteWorkOrderProceduresComponent,
    SiteWorkersComponent,
    InvitedUsersComponent,
    SiteContactsComponent,
    SiteRestrictionsComponent,
    SiteIncidentsComponent,
    CreateSiteComponent,
    AddEditAssetComponent,
    ContractorDetailsComponent,
    SharedContractorDetailsComponent,
    ContractorWorkersComponent,
    SharedContractorWorkersComponent,
    SiteOwnerUsersComponent,
    ContractorManagersComponent,
    AssetTypesComponent,
    SiteTypesComponent,
    CompetencyTypesComponent,
    ContractorsComponent,
    LiveSessionsComponent,
    SiteSessionsComponent,
    WorkerSessionsComponent,
    SessionPhotoModalComponent,
    SiteFormModalComponent,
    ContractorContactsComponent,
    SiteMapComponent,
    UserSearchComponent,
    WorkOrdersOverviewComponent,
    AssetCertificateComponent,
    AccordionSectionComponent,
    DateRangeFriendlyComponent,
    GroupedCompetencyMultiselectComponent,
    ActionBarComponent,
    TocCompetencyRowComponent,
    AddDocumentsComponent,
    ChangeStatusModalComponent,
    CheckoutModalComponent,
    EditCompetenciesComponent,
    EditSiteRequiredCompetenciesComponent,
    EditScheduleModalComponent,
    EditDescriptionModalComponent,
    EditMinPartyModalComponent,
    EditSiteFormModalComponent,
    StepProgressBarComponent,
    DateFriendlyComponent,
    WorkOrderStateBadgeComponent,
    CompetencyCardComponent,
    SignatureUploadComponent,
    DashboardComponent,
    LargeNumberDisplayComponent,
    WorkOrderBarGraphComponent,
    DashboardCardComponent,
    OverdueHealthCheckListComponent,
    TextFilterBoxComponent,
    PluralPipe,
    CompetencyShortNamePipe,
    CompetencyBadgeColorPipe,
    WorkOrderModalComponent,
    AssignTrainingModalComponent,
    ResendInductionReminderModalComponent,
    LiveSessionsModalComponent,
    AutoTableComponent,
    SiteFormsComponent,
    SiteFormsDetailsComponent,
    SiteFormsCreateComponent,
    SiteFormsResponseComponent,
    SiteFormsResponsesTableComponent,
    SiteFormsPreviewComponent,
    SiteFormsLinkSitesModalComponent,
    SiteFormEntryModalComponent,
    SiteFormTableModalComponent,
    InviteUsersComponent,
    ResultsModalComponent,
    ProcedureFormPageComponent,
    ProcedureDetailsPageComponent,
    CreateFromProcedureFormPageComponent,
    WorkOrderFormComponent,
    DisableControlDirective,
    SwitchCasesDirective,
    TextareaAutoresizeDirective,
    OnlyNumbersDirective,
    InboxComponent,
    AssetRestrictionApprovalComponent,
    SiteRestrictionApprovalComponent,
    ScheduleDisplaySectionComponent,
    AssetPageComponent,
    EditAvailabilityModalComponent,
    ApproveAvailabilityModalComponent,
    ApproveCancelledAvailabilityModalComponent,
    AddAvailabilityModalComponent,
    AvailabilityHistoryComponent,
    InviteContractorComponent,
    ContractorDashboardComponent,
    AddCertificateModalComponent,
    AdminUsersComponent,
    AdminManageTypesComponent,
    ContractorManagerContractorCertificatesComponent,
    PowerStationOwnerContractorCertificatesComponent,
    ContractorsListComponent,
    ContractorCertificateApprovalComponent,
    WorkerCertificateApprovalComponent,
    ContractorWorkerPageComponent,
    IntlPhoneCodeFieldComponent,
    ManageTrainingsComponent,
    TrainingPageComponent,
    EditVideoSectionModalComponent,
    EditPdfSectionModalComponent,
    TrainingOverviewComponent,
    TrainingSectionComponent,
    TrainingVideoComponent,
    TrainingPdfComponent,
    TrainingQuestionComponent,
    EditTrainingPageComponent,
    WorkerTrainingListComponent,
    ContractorAcceptanceListComponent,
    VideoPlayerComponent,
    PdfViewerComponent,
    QuestionsPageComponent,
    ChangePasswordModalComponent,
    SiteSessionCompetenciesComponent,
    ContractorSiteOwnerLinksComponent,
    AddContractorSiteOwnerLinkModalComponent,
    CheckInComponent,
    ChooseWorkersModalComponent,
    ViewPendingScheduleItemsModal,
    ChooseWorkOrderModalComponent,
    AdminAllSiteScheduleComponent,
    AllSiteScheduleComponent,
    SiteScheduleComponent,
    SchedulerComponent,
    SchedulerFiltersComponent,
    WorkerSearchComponent,
    UserSiteDetailsComponent,
    ManageWorkerCompetenciesComponent,
    EditWorkerSiteModalComponent,
    MultiEditChooseSiteTypeModalComponent,
    UserDetailsModalComponent,
    UsernameDisplayComponent,
    WorkerScheduleSiteListComponent,
    WorkerSiteScheduleComponent,
    SiteFormResponsePreviewPaneComponent,
    OemProceduresComponent,
    SendEmailComponent,
    SiteSiteSessionsComponent,
    ContractorListForTrainingComponent,
    WorkOrderSearchFieldComponent,
    SkeletonLoadingRowComponent,
    SkeletonLoadingFieldComponent,
    SkeletonLoadingCardGridComponent,
    CardSectionHeaderComponent,
    TableActionBarComponent,
    FilterToggleGroupComponent,
    FilterSummaryDisplayComponent,
    TopBannerComponent,
    AcceptCompetencyModalComponent,
    RejectCompetencyModalComponent,
    UploadEvidenceModalComponent,
    AddCompetencyFormComponent,
    WorkerManageCompetenciesComponent,
  ],
  entryComponents: [
    AddContractorSiteOwnerLinkModalComponent,
    SessionPhotoModalComponent,
    SiteFormModalComponent,
    AddDocumentsComponent,
    ChangeStatusModalComponent,
    ChooseWorkersModalComponent,
    ViewPendingScheduleItemsModal,
    ChooseWorkOrderModalComponent,
    CheckoutModalComponent,
    EditCompetenciesComponent,
    EditSiteRequiredCompetenciesComponent,
    EditScheduleModalComponent,
    AddAvailabilityModalComponent,
    EditWorkerSiteModalComponent,
    MultiEditChooseSiteTypeModalComponent,
    EditAvailabilityModalComponent,
    ApproveAvailabilityModalComponent,
    ApproveCancelledAvailabilityModalComponent,
    EditDescriptionModalComponent,
    EditMinPartyModalComponent,
    EditSiteFormModalComponent,
    WorkOrderModalComponent,
    AssignTrainingModalComponent,
    ResendInductionReminderModalComponent,
    LiveSessionsModalComponent,
    SiteFormsLinkSitesModalComponent,
    SiteFormEntryModalComponent,
    SiteFormTableModalComponent,
    ResultsModalComponent,
    CreateFromProcedureFormPageComponent,
    WorkOrderFormComponent,
    AddCertificateModalComponent,
    EditVideoSectionModalComponent,
    EditPdfSectionModalComponent,
    ChangePasswordModalComponent,
    UserDetailsModalComponent,
    AcceptCompetencyModalComponent,
    RejectCompetencyModalComponent,
    UploadEvidenceModalComponent,
  ],
  exports: [
    GroupedCompetencyMultiselectComponent,
    TextareaAutoresizeDirective,
    OnlyNumbersDirective,
    CardTabsComponent,
    UserProfileComponent,
    ReportsComponent,
    SiteInductionReportComponent,
    SiteFromReportComponent,
    RestrictionsReportComponent,
    ConfinedSpaceCompetencyAndTrainingReportComponent,
    RoleNamePipe,
    KeysPipe,
    SafePipe,
    CamelCaseToSpacePipe,
    CompetencyShortNamePipe,
    CompetencyBadgeColorPipe,
    CapitaliseWordsPipe,
    SitesComponent,
    SiteTabMenuComponent,
    SiteOwnerSitesComponent,
    SiteDetailsComponent,
    SiteOwnerDetailsComponent,
    SiteAssetsComponent,
    SiteLocationComponent,
    CreateSiteComponent,
    AddEditAssetComponent,
    ContractorDetailsComponent,
    SharedContractorDetailsComponent,
    ContractorWorkersComponent,
    SharedContractorWorkersComponent,
    GooglePlaceModule,
    SiteOwnerUsersComponent,
    ContractorManagersComponent,
    AssetTypesComponent,
    SiteTypesComponent,
    CompetencyTypesComponent,
    ContractorsComponent,
    SiteSessionsComponent,
    WorkerSessionsComponent,
    ContractorContactsComponent,
    SiteMapComponent,
    AccordionSectionComponent,
    DateFriendlyComponent,
    WorkOrderStateBadgeComponent,
    CompetencyCardComponent,
    SignatureUploadComponent,
    UsernameDisplayComponent,
    OemProceduresComponent,
    SendEmailComponent,
    WorkOrderSearchFieldComponent,
    SkeletonLoadingRowComponent,
    SkeletonLoadingFieldComponent,
    SkeletonLoadingCardGridComponent,
    CardSectionHeaderComponent,
    TableActionBarComponent,
    FilterToggleGroupComponent,
    FilterSummaryDisplayComponent,
    TextFilterBoxComponent,
    TopBannerComponent,
    AddCompetencyFormComponent,
    WorkerManageCompetenciesComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
